import { render, staticRenderFns } from "./start-settings.vue?vue&type=template&id=64866db1&scoped=true"
import script from "./start-settings.vue?vue&type=script&lang=js"
export * from "./start-settings.vue?vue&type=script&lang=js"
import style0 from "./start-settings.vue?vue&type=style&index=0&id=64866db1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64866db1",
  null
  
)

export default component.exports